import { Injectable } from '@angular/core';
import {
  AccountsSelectorPageQuery,
  AccountTypesPageQuery,
  BrandOrg,
  BrandOrgsPageQuery,
  UsersPageQuery,
} from 'graphql-api/gql-api-interfaces';
import { Observable, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import {
  AccountsSelectorGQL,
  AccountTypesGQL,
  BrandOrgsGQL,
  UsersGQL,
} from '../queries';

@Injectable()
export class EmailSelectorService {
  constructor(
    private usersGQL: UsersGQL,
    private accountsSelectorGQL: AccountsSelectorGQL,
    private brandOrgsGQL: BrandOrgsGQL,
    private accountTypesGQL: AccountTypesGQL,
  ) {}

  public getAccountTypes(query: AccountTypesPageQuery) {
    return this.accountTypesGQL
      .fetch({
        query: {
          ...query,
        },
      })
      .pipe(
        take(1),
        map((result) => ({
          items: result.data.accountTypes?.items ?? [],
          total: result.data.accountTypes?.total ?? 0,
        })),
        catchError((err) => {
          console.error(err);
          return throwError(err);
        }),
      );
  }

  public getBrandOrgs(
    query: BrandOrgsPageQuery,
  ): Observable<{ items: BrandOrg[]; total: number }> {
    return this.brandOrgsGQL
      .fetch({
        query,
      })
      .pipe(
        take(1),
        map(
          (result) =>
            ({
              items: result.data.brandOrgs?.items ?? [],
              total: result.data.brandOrgs?.total ?? 0,
            } as { items: BrandOrg[]; total: number }),
        ),
      );
  }

  public getAccountSelector(query: AccountsSelectorPageQuery) {
    return this.accountsSelectorGQL
      .fetch({
        query,
      })
      .pipe(
        take(1),
        map((result) => ({
          items: result.data.accountsSelector?.items ?? [],
          total: result.data.accountsSelector?.total ?? 0,
        })),
      );
  }

  public getUsers(query: UsersPageQuery) {
    return this.usersGQL
      .fetch({
        query,
      })
      .pipe(
        take(1),
        map((result) => ({
          items: result.data.users?.items ?? [],
          total: result.data.users?.total ?? 0,
        })),
      );
  }
}
